module.exports = __webpack_public_path__ + "img/chr_ts_22.9ec7a095.png";